import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import SystemTimeOut from "./views/SystemTimeOut.vue";
// User
import BuffetUser from "./views/user/buffet/BuffetUser.vue";
import SingleDishMealUser from "./views/user/singledishmeal/SingleDishMealUser.vue";
import TakeOutUserTable from "./views/user/takeouttable/TakeOutUserTable.vue";
import CartTakeOutTable from "./views/user/takeouttable/CartTakeOutTable.vue";
import CartMenu from "./views/user/cartmenu/CartMenu.vue";
import MyOrder from "./views/user/myorder/MyOrder.vue";
import ThankYouUser from "./views/user/thankyou/ThankYouUser.vue";
import NameTakeOutUser from "./views/user/takeout/NameTakeOutUser.vue";
import TakeOutUser from "./views/user/takeout/TakeOutUser.vue";
import CartTakeOutUser from "./views/user/takeout/CartTakeOutUser.vue";
import ThankYouTakeOut from "./views/user/takeout/ThankYouTakeOut.vue";
// User Order Online Pick Up
import NameOrderOnlinePickUp from "./views/user/orderonlinepickup/NameOrderOnlinePickUp.vue";
import OrderOnlinePickUp from "./views/user/orderonlinepickup/OrderOnlinePickUp.vue";
import CartOrderOnlinePickUp from "./views/user/orderonlinepickup/CartOrderOnlinePickUp.vue";
import ThankYouOrderOnlinePickUp from "./views/user/orderonlinepickup/ThankYouOrderOnlinePickUp.vue";
// Admin
import PageAll from "./views/admin/PageAll.vue";
// Admin Dashboard
import Dashboard from "./views/admin/dashboard/Dashboard.vue";
// Admin Team
import Team from "./views/admin/team/Team.vue";
import InTimeWork from "./views/admin/team/teamaddtimework/InTimeWork.vue";
import OutTimeWork from "./views/admin/team/teamaddtimework/OutTimeWork.vue";
import WorkSchedule from "./views/admin/team/teamworkschedule/WorkSchedule.vue";
import ManageWorkSchedule from "./views/admin/team/teamworkschedule/ManageWorkSchedule.vue";
import AllSchedule from "./views/admin/team/teamworkschedule/AllSchedule.vue";
import LeaveWork from "./views/admin/team/teamleavework/LeaveWork.vue";
import MyTeam from "./views/admin/team/myteam/MyTeam.vue";
import AddTeam from "./views/admin/team/myteam/AddTeam.vue";
import EditTeam from "./views/admin/team/myteam/EditTeam.vue";
import ReportWork from "./views/admin/team/teamreportandsummary/ReportWork.vue";
import DetailReportWork from "./views/admin/team/teamreportandsummary/DetailReportWork.vue";
import EditReportWork from "./views/admin/team/teamreportandsummary/EditReportWork.vue";
import Summary from "./views/admin/team/teamreportandsummary/Summary.vue";
import PartTimeSummary from "./views/admin/team/teamreportandsummary/PartTimeSummary.vue";
import EmployeeSummary from "./views/admin/team/teamreportandsummary/EmployeeSummary.vue";
import DetailPartTimeSummary from "./views/admin/team/teamreportandsummary/DetailPartTimeSummary.vue";
import DetailEmployeeSummary from "./views/admin/team/teamreportandsummary/DetailEmployeeSummary.vue";
import EditPartTimeSummary from "./views/admin/team/teamreportandsummary/EditPartTimeSummary.vue";
import EditEmployeeSummary from "./views/admin/team/teamreportandsummary/EditEmployeeSummary.vue";
import DayOffRestaurant from "./views/admin/team/teamsetting/DayOffRestaurant.vue";
import PartTimeOT from "./views/admin/team/teamsetting/PartTimeOT.vue";
import HoursWorked from "./views/admin/team/teamsetting/HoursWorked.vue";
import Role from "./views/admin/team/teamsetting/Role.vue";
// Admin Account
import AccountDay from "./views/admin/account/accountcreate/AccountDay.vue";
import AccountRetrospect from "./views/admin/account/accountcreate/AccountRetrospect.vue";
import AccountReport from "./views/admin/account/accountreport/AccountReport.vue";
import DailyCostReport from "./views/admin/account/accountreport/DailyCostReport.vue";
import RemainingAssetReport from "./views/admin/account/accountreport/RemainingAssetReport.vue";
import IncomeStatement from "./views/admin/account/accountreport/IncomeStatement.vue";
import AccountSetting from "./views/admin/account/accountsetting/AccountSetting.vue";
// Admin Stock
import Stock from "./views/admin/stock/Stock.vue";
import StockReport from "./views/admin/stock/stocklist/StockReport.vue";
import MaterialNow from "./views/admin/stock/stocklist/MaterialNow.vue";
import StockInOut from "./views/admin/stock/stocklist/StockInOut.vue";
import AddLotin from "./views/admin/stock/stocklist/AddLotin.vue";
import AddLotinPo from "./views/admin/stock/stocklist/AddLotinPo.vue";
import AddLotout from "./views/admin/stock/stocklist/AddLotout.vue";
import AddLotoutSummarize from "./views/admin/stock/stocklist/AddLotoutSummarize.vue";
import AllLot from "./views/admin/stock/stocklist/AllLot.vue";
import LotDetailIn from "./views/admin/stock/stocklist/LotDetailIn.vue";
import LotDetailInEdit from "./views/admin/stock/stocklist/LotDetailInEdit.vue";
import LotDetailOut from "./views/admin/stock/stocklist/LotDetailOut.vue";
import LotDetailOutEdit from "./views/admin/stock/stocklist/LotDetailOutEdit.vue";
import PurchaseOrder from "./views/admin/stock/stocklist/PurchaseOrder.vue";
import PurchaseOrderNew from "./views/admin/stock/stocklist/PurchaseOrderNew.vue";
import PurchaseOrderNewDetail from "./views/admin/stock/stocklist/PurchaseOrderNewDetail.vue";
import PurchaseOrderDetail from "./views/admin/stock/stocklist/PurchaseOrderDetail.vue";
import StockMaterial from "./views/admin/stock/stockmaterial/StockMaterial.vue";
import StockType from "./views/admin/stock/stocksetting/StockType.vue";
import StockSource from "./views/admin/stock/stocksetting/StockSource.vue";
import StockUnit from "./views/admin/stock/stocksetting/StockUnit.vue";
import StockZone from "./views/admin/stock/stocksetting/StockZone.vue";
// Admin Restaurant
import Restaurant from "./views/admin/restaurant/Restaurant.vue";
import PosList from "./views/admin/restaurant/PosList.vue";
import PosTableDetail from "./views/admin/restaurant/PosTableDetail.vue";
import TakeOutAdmin from "./views/admin/restaurant/TakeOutAdmin.vue";
import PaymentTakeOutAdmin from "./views/admin/restaurant/PaymentTakeOutAdmin.vue";
import BillRetrospect from "./views/admin/restaurant/BillRetrospect.vue";
import SummaryBeforeCloseShop from "./views/admin/restaurant/SummaryBeforeCloseShop.vue";
import SaleReportDay from "./views/admin/restaurant/SaleReportDay.vue";
import SaleStatistic from "./views/admin/restaurant/SaleStatistic.vue";
import QuickFoodOrder from "./views/admin/restaurant/QuickFoodOrder.vue";
import ManageFood from "./views/admin/restaurant/ManageFood.vue";
import FoodDetail from "./views/admin/restaurant/FoodDetail.vue";
import ToppingDetail from "./views/admin/restaurant/ToppingDetail.vue";
import AddFood from "./views/admin/restaurant/AddFood.vue";
import AddTopping from "./views/admin/restaurant/AddTopping.vue";
import BuffetManage from "./views/admin/restaurant/BuffetManage.vue";
import SaleReport from "./views/admin/restaurant/SaleReport.vue";
import OrderList from "./views/admin/restaurant/OrderList.vue";
import BillRetrospectAll from "./views/admin/restaurant/BillRetrospectAll.vue";
import CloseRetrospectall from "./views/admin/restaurant/CloseRetrospectall.vue";
import CloseRetrospectDetail from "./views/admin/restaurant/CloseRetrospectDetail.vue";
import AdvertiseBuffet from "./views/admin/restaurant/AdvertiseBuffet.vue";
import AdvertiseSingleDishMeal from "./views/admin/restaurant/AdvertiseSingleDishMeal.vue";
import AdvertiseTakeOut from "./views/admin/restaurant/AdvertiseTakeOut.vue";
import SettingRestaurant from "./views/admin/restaurant/SettingRestaurant.vue";
import CreateTaxInvoice from "./views/admin/restaurant/CreateTaxInvoice.vue";
import BillInvoicePrint from "./views/admin/restaurant/BillInvoicePrint.vue";
import BillInvoicePrintDetail from "./views/admin/restaurant/BillInvoicePrintDetail.vue";
// Admin Content Website
import Content from "./views/admin/content/Content.vue";
import ContentOrder from "./views/admin/content/contentpurchase/ContentOrder.vue";
import ContentRetrospect from "./views/admin/content/contentpurchase/ContentRetrospect.vue";
import ContentOrderDetail from "./views/admin/content/contentpurchase/ContentOrderDetail.vue";
import ContentReport from "./views/admin/content/contentpurchase/ContentReport.vue";
import ContentCustomer from "./views/admin/content/contentcustomer/ContentCustomer.vue";
import ContentSlide from "./views/admin/content/contentmanageimage/ContentSlide.vue";
import ContentManageBanner from "./views/admin/content/contentmanageimage/ContentManageBanner.vue";
import ContentManageImportCountry from "./views/admin/content/contentmanageimage/ContentManageImportCountry.vue";
import ContentBlog from "./views/admin/content/contentblog/ContentBlog.vue";
import ContentAddBlog from "./views/admin/content/contentblog/ContentAddBlog.vue";
import ContentEditBlog from "./views/admin/content/contentblog/ContentEditBlog.vue";
import ContentAbout from "./views/admin/content/contentsetting/ContentAbout.vue";
import ContentService from "./views/admin/content/contentsetting/ContentService.vue";
import ContentContact from "./views/admin/content/contentsetting/ContentContact.vue";
import ContentPayment from "./views/admin/content/contentsetting/ContentPayment.vue";
import ContentDeliveryRate from "./views/admin/content/contentsetting/ContentDeliveryRate.vue";
// Admin Profile
import Profile from "./views/admin/profile/Profile.vue";
import UserManual from "@/views/admin/usermanual/UserManual";
import PrinterIPConfig from "@/views/maintenance/printerfix/PrinterIPConfig";
// Maintenance
// Pricing Page
// import PricingPage from "@/views/pricing/PricingPage.vue";
// import PricingQRPaymentPage from "@/views/pricing/PricingQRPaymentPage.vue";
// import ThankYouPricingPage from "@/views/pricing/ThankYouPricingPage.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // Login
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    // System Time Out
    {
      path: "/systemtimeout",
      name: "systemTimeOut",
      component: SystemTimeOut,
    },
    // User
    {
      path: "/buffetuser/:id/:token",
      name: "buffetUser",
      component: BuffetUser,
    },
    {
      path: "/singledishmealuser/:id/:token",
      name: "singleDishMealUser",
      component: SingleDishMealUser,
    },

    {
      path: "/takeoutusertable/:token",
      name: "takeOutUserTable",
      component: TakeOutUserTable,
    },
    {
      path: "/carttakeouttable/:token",
      name: "cartTakeOutTable",
      component: CartTakeOutTable,
    },
    {
      path: "/cartmenu/:type/:id/:token",
      name: "cartMenu",
      component: CartMenu,
    },
    {
      path: "/myorder/:type/:id/:token",
      name: "myOrder",
      component: MyOrder,
    },
    {
      path: "/thankyouuser",
      name: "thankYouUser",
      component: ThankYouUser,
    },
    {
      path: "/thankyoutakeout",
      name: "thankYouTakeOut",
      component: ThankYouTakeOut,
    },
    // User กลับบ้าน
    {
      path: "/nametakeoutuser",
      name: "nameTakeOutUser",
      component: NameTakeOutUser,
    },
    {
      path: "/takeoutuser",
      name: "takeOutUser",
      component: TakeOutUser,
    },
    {
      path: "/carttakeoutuser",
      name: "cartTakeOutUser",
      component: CartTakeOutUser,
    },
    // User สั่งออนไลน์จากหน้าเว็บ มารับที่ร้าน
    {
      path: "/nameorderonlinepickup",
      name: "nameOrderOnlinePickUp",
      component: NameOrderOnlinePickUp,
    },
    {
      path: "/orderonlinepickup",
      name: "orderOnlinePickUp",
      component: OrderOnlinePickUp,
    },
    {
      path: "/cartorderonlinepickup",
      name: "cartOrderOnlinePickUp",
      component: CartOrderOnlinePickUp,
    },
    {
      path: "/thankyouorderonlinepickup/:token",
      name: "thankYouOrderOnlinePickUp",
      component: ThankYouOrderOnlinePickUp,
    },

    // Admin
    // Admin Stock
    {
      path: "/purchaseorderdetail/:id",
      name: "purchaseOrderDetail",
      component: PurchaseOrderDetail,
    },
    // pricing Page
    // {
    //   path: "/pricingpage/:ip",
    //   name: "pricingPage",
    //   component: PricingPage,
    // },
    // {
    //   path: "/pricingqrpaymentpage/:ip/:package_id",
    //   name: "pricingQRPaymentPage",
    //   component: PricingQRPaymentPage,
    // },
    // {
    //   path: "/thankyoupricingpage/:ip",
    //   name: "thankYouPricingPage",
    //   component: ThankYouPricingPage,
    // },
    {
      path: '/billinvoiceprintdetail/:id',
      name: 'BillInvoicePrintDetail',
      component: BillInvoicePrintDetail
    },
    {
      path: "/",
      name: "pageAll",
      component: PageAll,
      children: [
        // Maintenance
        {
          path: "/printersetting",
          name: "printersetting",
          component: PrinterIPConfig,
        },
        // Admin Dashboard
        {
          path: "/",
          name: "dashboard",
          component: Dashboard,
        },
        {
          path: "/dashboard",
          name: "dashboard",
          component: Dashboard,
        },
        // Admin Team
        {
          path: "/team",
          name: "team",
          component: Team,
        },
        {
          path: "/intimework",
          name: "inTimeWork",
          component: InTimeWork,
        },
        {
          path: "/outtimework",
          name: "outTimeWork",
          component: OutTimeWork,
        },
        {
          path: "/workschedule",
          name: "workSchedule",
          component: WorkSchedule,
        },
        {
          path: "/manageworkschedule",
          name: "manageWorkSchedule",
          component: ManageWorkSchedule,
        },
        {
          path: "/allschedule",
          name: "allSchedule",
          component: AllSchedule,
        },

        {
          path: "/leavework",
          name: "leaveWork",
          component: LeaveWork,
        },
        {
          path: "/myteam",
          name: "myTeam",
          component: MyTeam,
        },
        {
          path: "/addteam",
          name: "addTeam",
          component: AddTeam,
        },
        {
          path: "/editteam",
          name: "editTeam",
          component: EditTeam,
        },
        {
          path: "/reportwork",
          name: "reportWork",
          component: ReportWork,
        },
        {
          path: "/detailreportwork",
          name: "detailReportWork",
          component: DetailReportWork,
        },
        {
          path: "/editreportwork",
          name: "editReportWork",
          component: EditReportWork,
        },
        {
          path: "/summary",
          name: "summary",
          component: Summary,
        },
        {
          path: "/parttimesummary",
          name: "partTimeSummary",
          component: PartTimeSummary,
        },
        {
          path: "/employeesummary",
          name: "employeeSummary",
          component: EmployeeSummary,
        },
        {
          path: "/detailparttimesummary",
          name: "detailPartTimeSummary",
          component: DetailPartTimeSummary,
        },
        {
          path: "/detailemployeesummary",
          name: "detailEmployeeSummary",
          component: DetailEmployeeSummary,
        },

        {
          path: "/editparttimesummary",
          name: "editPartTimeSummary",
          component: EditPartTimeSummary,
        },
        {
          path: "/editemployeesummary",
          name: "editEmployeeSummary",
          component: EditEmployeeSummary,
        },
        {
          path: "/dayoffrestaurant",
          name: "dayOffRestaurant",
          component: DayOffRestaurant,
        },
        {
          path: "/parttimeot",
          name: "partTimeOT",
          component: PartTimeOT,
        },
        {
          path: "/hoursworked",
          name: "hoursWorked",
          component: HoursWorked,
        },
        {
          path: "/role",
          name: "role",
          component: Role,
        },
        // Admin Account
        {
          path: "/accountday",
          name: "accountDay",
          component: AccountDay,
        },
        {
          path: "/accountretrospect",
          name: "accountRetrospect",
          component: AccountRetrospect,
        },
        {
          path: "/accountreport",
          name: "accountReport",
          component: AccountReport,
        },
        {
          path: "/dailycostreport",
          name: "dailyCostReport",
          component: DailyCostReport,
        },
        {
          path: "/remainingassetreport",
          name: "remainingAssetReport",
          component: RemainingAssetReport,
        },
        {
          path: "/incomestatement",
          name: "incomeStatement",
          component: IncomeStatement,
        },
        {
          path: "/accountsetting",
          name: "accountSetting",
          component: AccountSetting,
        },
        // Admin Stock
        {
          path: "/stock",
          name: "stock",
          component: Stock,
        },
        {
          path: "/stockreport",
          name: "stockReport",
          component: StockReport,
        },
        {
          path: "/materialnow",
          name: "materialNow",
          component: MaterialNow,
        },
        {
          path: "/stockinout",
          name: "stockInOut",
          component: StockInOut,
        },
        {
          path: "/addlotin",
          name: "addLotin",
          component: AddLotin,
        },
        {
          path: "/addlotinpo",
          name: "addLotinPo",
          component: AddLotinPo,
        },
        {
          path: "/addlotout",
          name: "addLotout",
          component: AddLotout,
        },
        {
          path: "/addlotoutsummarize",
          name: "addLotoutSummarize",
          component: AddLotoutSummarize,
        },

        {
          path: "/alllot",
          name: "allLot",
          component: AllLot,
        },
        {
          path: "/lotdetailin",
          name: "lotDetailIn",
          component: LotDetailIn,
        },
        {
          path: "/lotdetailinedit",
          name: "lotDetailInEdit",
          component: LotDetailInEdit,
        },
        {
          path: "/lotdetailout",
          name: "lotDetailOut",
          component: LotDetailOut,
        },
        {
          path: "/lotdetailoutedit",
          name: "lotDetailOutEdit",
          component: LotDetailOutEdit,
        },
        {
          path: "/purchaseorder",
          name: "purchaseOrder",
          component: PurchaseOrder,
        },
        {
          path: "/purchaseordernew",
          name: "purchaseOrderNew",
          component: PurchaseOrderNew,
        },
        {
          path: "/purchaseordernewdetail",
          name: "purchaseOrderNewDetail",
          component: PurchaseOrderNewDetail,
        },
        {
          path: "/stockmaterial",
          name: "stockMaterial",
          component: StockMaterial,
        },
        {
          path: "/stocktype",
          name: "stockType",
          component: StockType,
        },
        {
          path: "/stocksource",
          name: "stockSource",
          component: StockSource,
        },
        {
          path: "/stockunit",
          name: "stockUnit",
          component: StockUnit,
        },
        {
          path: "/stockzone",
          name: "stockZone",
          component: StockZone,
        },
        // Admin Restaurant
        {
          path: "/restaurant",
          name: "restaurant",
          component: Restaurant,
        },
        {
          path: "/poslist",
          name: "posList",
          component: PosList,
        },
        {
          path: "/postabledetail",
          name: "posTableDetail",
          component: PosTableDetail,
        },
        {
          path: "/takeoutadmin",
          name: "takeOutAdmin",
          component: TakeOutAdmin,
        },
        {
          path: "/paymenttakeoutadmin",
          name: "paymentTakeOutAdmin",
          component: PaymentTakeOutAdmin,
        },
        {
          path: "/billretrospect",
          name: "billRetrospect",
          component: BillRetrospect,
        },
        {
          path: "/summarybeforecloseshop",
          name: "summaryBeforeCloseShop",
          component: SummaryBeforeCloseShop,
        },
        {
          path: "/salereportday",
          name: "saleReportDay",
          component: SaleReportDay,
        },
        {
          path: "/salestatistic",
          name: "saleStatistic",
          component: SaleStatistic,
        },
        {
          path: "/quickfoodorder",
          name: "quickFoodOrder",
          component: QuickFoodOrder,
        },
        {
          path: "/managefood",
          name: "manageFood",
          component: ManageFood,
        },
        {
          path: "/fooddetail",
          name: "foodDetail",
          component: FoodDetail,
        },
        {
          path: "/toppingdetail",
          name: "toppingDetail",
          component: ToppingDetail,
        },
        {
          path: "/addfood",
          name: "addFood",
          component: AddFood,
        },
        {
          path: "/addtopping",
          name: "addTopping",
          component: AddTopping,
        },
        {
          path: "/buffetmanage",
          name: "buffetManage",
          component: BuffetManage,
        },
        {
          path: "/salereport",
          name: "saleReport",
          component: SaleReport,
        },
        {
          path: "/billretrospectall",
          name: "billRetrospectAll",
          component: BillRetrospectAll,
        },
        {
          path: "/closeretrospectall",
          name: "closeRetrospectall",
          component: CloseRetrospectall,
        },
        {
          path: "/closeretrospectdetail",
          name: "closeRetrospectDetail",
          component: CloseRetrospectDetail,
        },
        {
          path: "/advertisebuffet",
          name: "advertiseBuffet",
          component: AdvertiseBuffet,
        },
        {
          path: "/advertisesingledishmeal",
          name: "advertiseSingleDishMeal",
          component: AdvertiseSingleDishMeal,
        },
        {
          path: "/advertisetakeout",
          name: "advertiseTakeOut",
          component: AdvertiseTakeOut,
        },
        {
          path: "/settingrestaurant",
          name: "settingRestaurant",
          component: SettingRestaurant,
        },
        {
          path: "/createtaxinvoice/:id",
          name: "createTaxInvoice",
          component: CreateTaxInvoice,
        },
        {
          path: '/billinvoiceprint/:id',
          name: 'BillInvoicePrint',
          component: BillInvoicePrint
        },
        {
          path: "/orderlist",
          name: "orderList",
          component: OrderList,
        },
        // Admin Content Website
        {
          path: "/content",
          name: "content",
          component: Content,
        },
        {
          path: "/contentorder",
          name: "contentOrder",
          component: ContentOrder,
        },
        {
          path: "/contentretrospect",
          name: "contentRetrospect",
          component: ContentRetrospect,
        },
        {
          path: "/contentorderdetail/:type",
          name: "contentOrderDetail",
          component: ContentOrderDetail,
        },
        {
          path: "/contentreport",
          name: "contentReport",
          component: ContentReport,
        },
        {
          path: "/contentcustomer",
          name: "contentCustomer",
          component: ContentCustomer,
        },
        {
          path: "/contentslide",
          name: "contentSlide",
          component: ContentSlide,
        },
        {
          path: "/contentmanagebanner",
          name: "contentManageBanner",
          component: ContentManageBanner,
        },
        {
          path: "/contentmanageimportcountry",
          name: "contentManageImportCountry",
          component: ContentManageImportCountry,
        },
        {
          path: "/contentblog",
          name: "contentBlog",
          component: ContentBlog,
        },
        {
          path: "/contentaddblog",
          name: "contentAddBlog",
          component: ContentAddBlog,
        },
        {
          path: "/contenteditblog",
          name: "contentEditBlog",
          component: ContentEditBlog,
        },
        {
          path: "/contentabout",
          name: "contentAbout",
          component: ContentAbout,
        },
        {
          path: "/contentservice",
          name: "contentService",
          component: ContentService,
        },
        {
          path: "/contentcontact",
          name: "contentContact",
          component: ContentContact,
        },
        {
          path: "/contentpayment",
          name: "contentPayment",
          component: ContentPayment,
        },
        {
          path: "/contentdeliveryrate",
          name: "contentDeliveryRate",
          component: ContentDeliveryRate,
        },
        // Admin Profile
        {
          path: "/profile",
          name: "profile",
          component: Profile,
        },
        // Admin User Manual
        {
          path: "/usermanual",
          name: "usermanual",
          component: UserManual,
        },
      ],
    },
  ],
});
